import { gql } from '@graphql/__generated__';

export const GET_LOST_STAGE = gql(/* GraphQL */ `
  query BuyerLeadWorkflowGetLostStage {
    lead_stages(
      where: {
        pipeline: { name: { _eq: "house_sales" }, lead_type: { _eq: "buyer" } }
        status: { _eq: lost }
      }
      order_by: { order_nr: asc_nulls_first }
    ) {
      id
      label
      status
    }
  }
`);

export const GET_WON_STAGE = gql(/* GraphQL */ `
  query BuyerLeadWorkflowGetWonStage {
    lead_stages(
      where: {
        pipeline: { name: { _eq: "house_sales" }, lead_type: { _eq: "buyer" } }
        status: { _eq: won }
      }
      order_by: { order_nr: asc_nulls_first }
      limit: 1
    ) {
      id
      status
    }
  }
`);

export const GET_ACTIVATION_TARGET = gql(/* GraphQL */ `
  query BuyerLeadWorkflowGetActivationTarget($id: uuid!) {
    buyer_leads_by_pk(id: $id) {
      id
      tenant_id
      lead_stage {
        id
        status
      }
    }
    lead_stages(
      where: {
        pipeline: { name: { _eq: "house_sales" }, lead_type: { _eq: "buyer" } }
        status: { _eq: active }
      }
      order_by: { order_nr: asc_nulls_first }
      limit: 1
    ) {
      id
      status
    }
  }
`);

export const UPDATE_BUYER_LEAD = gql(/* GraphQL */ `
  mutation BuyerLeadWorkflowUpdateBuyerLead(
    $id: uuid!
    $set: buyer_leads_set_input!
  ) {
    update_buyer_leads_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      stage_id
      lead_stage {
        id
        status
      }
    }
  }
`);
